/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import {
  AfterContentInit,
  Component,
  ContentChild,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  Renderer2,
} from '@angular/core';

import {
  DEFAULT_DESKTOP_PAGE_ENVIRONMENT,
  PAGE_ENVIRONMENT_PROVIDER,
  PageEnvironment,
  PageEnvironmentManager,
  PageEnvironmentProvider,
} from '../page-environment';

/**
 * Page component supports following page layout types:
 * - flat for scrollable content without paddings
 * - form for scrollable content with paddings
 * - catalog for not scrollable content without paddings
 * - card for not scrollable content wihtout paddings shifted to the top
 */
export type PageLayoutType = 'flat' | 'form' | 'card' | 'catalog';

@Component({
  standalone: false,
  selector: 'gh-page',
  templateUrl: 'page.component.html',
  styleUrls: ['page.component.scss'],
})
export class PageComponent implements OnInit, AfterContentInit, OnDestroy {
  @Input() layout: PageLayoutType = 'flat';

  @ContentChild(<any>PAGE_ENVIRONMENT_PROVIDER, { static: false }) pageEnvironmentProvider?: PageEnvironmentProvider;

  private environment: PageEnvironment;

  constructor(private renderer: Renderer2,
              private pageEnvironmentManager: PageEnvironmentManager,
              private elementRef: ElementRef) {

  }

  ngOnInit(): void {
    this.renderer.addClass(this.elementRef.nativeElement, `page-${this.layout}-layout`);
  }

  ngAfterContentInit(): void {
    const { pageEnvironmentProvider } = this;
    this.environment = pageEnvironmentProvider
      ? pageEnvironmentProvider.environment
      : DEFAULT_DESKTOP_PAGE_ENVIRONMENT;
    this.pageEnvironmentManager.use(this.environment);
  }

  ngOnDestroy(): void {
    if (this.environment) {
      this.pageEnvironmentManager.unuse();
    }
  }
}
